export default __webpack_public_path__ + "static/pubmatic-37b6344793bdc5397a3d0c3c30d5244b.svg";